export enum WallSurfaceSide {
  BackSurface = 'back-surface',
  FrontSurface = 'front-surface',
}
